module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vskel6-69dc46dece11132303f66dc05d7d84d3.jpg";